module.exports = __webpack_public_path__ + "media/Components/Logos/icon-tool-totop-a1294f7d430f3fcfc3bcbc9f2e42b399.svg";